<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
    <toast-bar />
  </div>
</template>

<script>
import ToastBar from "@/components/global/notification/ToastBar";
const default_layout = "default";

export default {
    components: { ToastBar },
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + "-layout";
        }
    },
    created() {
    // nothing defined here (when this.$route.path is other than "/")
    // console.log(this.$route, this.$route.meta.layout);
    },
    updated() {
    // to remove error and success messages on each view changement
    // something defined here whatever the this.$route.path
    }
};
</script>

<style lang="scss"></style>
